import {ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { Observable, of } from 'rxjs';
import {mergeMap, map, catchError} from 'rxjs/operators';
import { IEpicDependency, IAppUser, IAppError } from '../../models';
import { IAppAction } from '../app-action';
import { sessionStateActions, signUpSocialError, signUpSocialSuccess } from './session-actions';
import { IAppState } from '../app-state';
import { sendToast, ToastType } from '../../helpers/sendToast';
import { fetchContactFamilyDetails, setContactOnLoginSuccess } from '../contact/contact-actions';
import { fetchCountries } from '../reference-data';
import { fetchHolidays } from '../holiday';

export const signUpSocialMediaEpic = (action$: ActionsObservable<IAppAction>, state$: StateObservable<IAppState>, {api, endPointKeys}:
    IEpicDependency): Observable<IAppAction> => action$.pipe(
        ofType(sessionStateActions.SIGNUP_SOCIAL),
        mergeMap(action => {
            var data = JSON.stringify(action.payload);
            return api.post(endPointKeys.api_contact, 'user/signUpBySocialMedia', data).pipe(
                map(result => result.data),
                mergeMap((appUser : IAppUser) => {
                    localStorage.removeItem("timedOut");
                    // sendToast(`Welcome ${appUser.firstName}`, ToastType.Success);
                    return of(signUpSocialSuccess(appUser),
                            setContactOnLoginSuccess(appUser),
                            fetchCountries(),
                            fetchHolidays(appUser.id),
                            fetchContactFamilyDetails(appUser.id));
                }),
                catchError(error => {
                    const appError : IAppError = { error, message: "Failed to sign up"};
                    sendToast(appError.message, ToastType.Error);
                    return of(signUpSocialError(appError));
                }))
        })
    )